import React from 'react';
import { MainLayout } from '../components/MainLayout';
import { useApp } from '../components/AppContext';

export function IDCheckIntro() {
  const { navigateDirectly } = useApp();

  const handleContinue = () => {
    navigateDirectly('id-terms');
  };

  return (
    <MainLayout showBack showBottomNav={false}>
      <div className="intro-screen-container">
        <div className="intro-header">
          <div className="intro-icon">
            <span className="text-4xl">🆔</span>
          </div>
          <h2 className="text-2xl font-bold text-[var(--ucm-text-dark)] mb-2">
            ID Verification
          </h2>
        </div>
        
        <div className="intro-content">
          <h3 className="text-xl font-semibold text-[var(--ucm-text-dark)] mb-6">
            Why we need to verify your ID
          </h3>
          
          <div className="intro-reasons">
            <div className="reason-item">
              <div className="reason-icon">
                <span className="text-white text-sm">🛡️</span>
              </div>
              <div className="reason-text">
                <strong className="block font-semibold text-[var(--ucm-text-dark)] mb-1">
                  Airport Security
                </strong>
                <p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed m-0">
                  Frankfurt Airport requires ID verification for all individuals accessing restricted areas during trials.
                </p>
              </div>
            </div>
            
            <div className="reason-item">
              <div className="reason-icon">
                <span className="text-white text-sm">✅</span>
              </div>
              <div className="reason-text">
                <strong className="block font-semibold text-[var(--ucm-text-dark)] mb-1">
                  Identity Confirmation
                </strong>
                <p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed m-0">
                  We verify that your identity matches your profile information for security and legal compliance.
                </p>
              </div>
            </div>
            
            <div className="reason-item">
              <div className="reason-icon">
                <span className="text-white text-sm">🏛️</span>
              </div>
              <div className="reason-text">
                <strong className="block font-semibold text-[var(--ucm-text-dark)] mb-1">
                  Regulatory Requirements
                </strong>
                <p className="text-sm text-[var(--ucm-text-medium)] leading-relaxed m-0">
                  German aviation authorities mandate identity verification for all trial operation participants.
                </p>
              </div>
            </div>
          </div>
          
          {/* Terms & Conditions Section */}
          <div className="terms-conditions-section">
            <h3 className="font-semibold text-[var(--ucm-dark-blue)] mb-4">
              Terms & Conditions for ID Photo Usage
            </h3>
            <div className="terms-content">
              <p className="text-sm text-[var(--ucm-dark-blue)] leading-relaxed mb-3 text-left">
                We collect your ID photo solely for verification purposes within our system.
              </p>
              
              <p className="text-sm font-semibold text-[var(--ucm-dark-blue)] mb-3 text-left">
                Your ID photo will be used exclusively for:
              </p>
              <ul className="terms-list text-sm text-[var(--ucm-dark-blue)] mb-4 list-disc list-inside">
                <li className="mb-2">Identity verification during profile setup</li>
                <li className="mb-2">Check-in and check-out processes</li>
                <li className="mb-2">Payroll verification and processing</li>
                <li className="mb-2">Internal security and compliance</li>
              </ul>
              
              <p className="text-sm text-[var(--ucm-dark-blue)] leading-relaxed mb-3 text-left">
                We do not share, sell, or use your ID photo for any other purposes. Your privacy and data security are our top priorities.
              </p>
              
              <p className="text-sm font-semibold text-[var(--ucm-dark-blue)] mb-0 text-left">
                By proceeding, you consent to this limited use of your ID photo.
              </p>
            </div>
          </div>
          
          <div className="trust-message">
            <p className="text-sm text-[var(--ucm-dark-blue)] leading-relaxed m-0">
              <strong>Secure process:</strong> ID verification is processed securely and images are encrypted. Documents are only used for verification purposes.
            </p>
          </div>
        </div>
        
        <div className="intro-actions">
          <button
            onClick={handleContinue}
            className="w-full h-14 bg-[var(--ucm-primary-teal)] text-white font-semibold rounded-full hover:bg-[var(--ucm-primary-teal-hover)] transition-colors duration-200"
          >
            Start ID Verification
          </button>
        </div>
      </div>
    </MainLayout>
  );
}